<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 is-flex is-justify-content-center">
        <h1>Aggiungi nuovo listino</h1>
      </div>
      <div class="body">
        <!-- INSERIMENTO LISTINO  -->
        <div class="step1 row" v-if="step === 1">
          <div class="col-md-6">
            <b-field label="Nome">
              <b-input id="step1" v-model="shipping_prices.nome"></b-input>
            </b-field>
          </div>
          <div class="col-md-6">
            <b-field label="Descrizione">
              <b-input v-model="shipping_prices.descrizione"></b-input>
            </b-field>
          </div>
          <div class="col-md-4">
            <button @click="cancel()" class="belt-btn my-red-btn">
              Annulla
            </button>
          </div>
          <div class="col-md-8">
            <button @click="step2()" class="belt-btn my-green-btn">
              Avanti
            </button>
          </div>
        </div>

        <!-- INSERIMENTO AREA GEOGRAFICA -->
        <div class="step2 row" v-if="step === 2">
          <div
            class="area col-md-12 row mb-5 justify-content-between"
            v-for="(geo_area, i) in geo_areasNr"
            :key="i"
          >
            <!-- AREA DA CONFERMARE -->
            <div
              v-if="!geo_areas[i].ok"
              class="area-no col-md-9 row align-items-center justify-self-start"
            >
              <label for="Area geaografica" class="col-md-5 col-12"
                ><b>Area geaografica N. {{i+1}}</b></label
              >
<!--              <input-->
<!--                type="text"-->
<!--                class="col-md-5 col-10"-->
<!--                v-model="geo_areas[i].name"-->
<!--                @keyup.enter="geo_areas[i].ok = true;"-->
<!--                @keyup="getSuggestions(geo_areas[i].name)"-->
<!--                :id="'step2' + i"-->
<!--                autocomplete="off"-->
<!--              />-->
<!--              <div class="suggestions">-->
<!--                <ul>-->
<!--                  <li v-for="s in suggestions">{{s.area_name}}</li>-->
<!--                </ul>-->
<!--              </div>-->
              <vue-google-autocomplete
                  :id="'step2' + i"
                  class="col-md-5 col-10"
                  classname="form-control"
                  types="(regions)"
                  v-on:placechanged="getAddressData"
              >
              </vue-google-autocomplete>
<!--              <a-->
<!--                class="green col-md-2 col-2 inputClick"-->
<!--                @click="geo_areas[i].ok = true"-->
<!--                ><i class="fas fa-check green"></i-->
<!--              ></a>-->


            </div>
            <!-- AREA CONFERMATA -->
<!--            <div v-else class="area-ok col-md-9 row align-items-center">-->
<!--              <label class="col-md-5 col-12"><b>Area geaografica</b></label>-->
<!--              <span class="text-capitalize col-md-5 col-10">{{-->
<!--                geo_areas[i].name-->
<!--              }}</span>-->
<!--              <a-->
<!--                class="orange col-md-2 col-2 inputClick"-->
<!--                @click="geo_areas[i].ok = false"-->
<!--                ><i class="fas fa-pen orange"></i-->
<!--              ></a>-->
<!--            </div>-->
            <div
              class="
                options
                col-md-3
                d-flex
                justify-content-between
                align-items-center
              "
            >
<!--              <div-->
<!--                class="-->
<!--                  italia-->
<!--                  d-flex-->
<!--                  justify-content-between-->
<!--                  align-items-baseline-->
<!--                "-->
<!--              >-->
<!--                <input-->
<!--                  class="col-md-2"-->
<!--                  :checked="geo_areas[i].italy"-->
<!--                  type="checkbox"-->
<!--                  :id="i"-->
<!--                  @change="geo_areas[i].italy = !geo_areas[i].italy"-->
<!--                />-->
<!--                <label-->
<!--                  @click="geo_areas[i].italy = !geo_areas[i].italy"-->
<!--                  :for="i"-->
<!--                  >Italia?</label-->
<!--                >-->
<!--              </div>-->
<!--              <a-->
<!--                v-if="i == geo_areas.length - 1"-->
<!--                @click="more('geo_area')"-->
<!--                class="blue"-->
<!--                ><i class="fas fa-plus"></i-->
<!--              ></a>-->
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="col-md-12">
              <p class="mt-5"><small>Aree ammesse: Stato, Regione, Provincia</small></p>
            </div>

          </div>

          <div class="col-md-12 buttons row">
            <div class="col-md-3">
              <button @click="cancel()" class="belt-btn my-red-btn">
                Annulla
              </button>
            </div>
            <div class="col-md-4">
              <button @click="step -= 1" class="belt-btn my-orange-btn">
                Indietro
              </button>
            </div>

            <div class="col-md-5">
              <button @click="step3()" class="belt-btn my-green-btn">
                Avanti
              </button>
            </div>
          </div>
        </div>

        <!-- INSERIMENTO RANKS -->
        <div class="step3 row" v-if="step === 3">
          <div
            class="rank col-md-12 row align-items-center"
            v-for="(rank, i) in ranksNr"
            :key="i"
          >
            <div class="row rank-no align-items-center col-md-9 col-9">
              <div class="col-md-6 col-12">
                <div
                  class="
                    row
                    justify-content-center
                    flex-column
                    align-items-center
                  "
                >
                  <label class="col-md-12" for="P/V min"><b>P/V min</b></label>
                  <b-input
                    :id="'step3' + i"
                    v-if="!ranks[i].ok"
                    class="col-md-12"
                    type="number"
                    v-model="ranks[i].min"
                  ></b-input>
                  <span v-else>{{ ranks[i].min }}</span>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div
                  class="
                    row
                    justify-content-center
                    flex-column
                    align-items-center
                  "
                >
                  <label class="col-md-12" for="P/V max"><b>P/V max</b></label>
                  <b-input
                    v-if="!ranks[i].ok"
                    class="col-md-12"
                    type="number"
                    align-items-center
                    v-model="ranks[i].max"
                  ></b-input>
                  <span v-else>{{ ranks[i].max }}</span>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div
                  class="
                    row
                    justify-content-center
                    flex-column
                    align-items-center
                  "
                >
                  <label class="col-md-12" for="Prezzo standard"
                    ><b>Prezzo standard</b></label
                  >
                  <b-input
                    v-if="!ranks[i].ok"
                    class="col-md-12"
                    type="number"
                    v-model="ranks[i].stPrice"
                    @keyup.native.enter="ranks[i].ok = true"
                  ></b-input>
                  <span v-else>{{ ranks[i].stPrice }}</span>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div
                  class="
                    row
                    justify-content-center
                    flex-column
                    align-items-center
                  "
                >
                  <label class="col-md-12" for="Prezzo express"
                    ><b>Prezzo express</b></label
                  >
                  <b-input
                    v-if="!ranks[i].ok"
                    class="col-md-12"
                    type="number"
                    v-model="ranks[i].exPrice"
                    @keyup.native.enter="ranks[i].ok = true"
                  ></b-input>
                  <span v-else>{{ ranks[i].exPrice }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-3">
              <a v-if="!ranks[i].ok" @click="ranks[i].ok = true" class="green"
                ><i class="fas fa-check green"></i
              ></a>
              <a v-else @click="ranks[i].ok = false" class="orange"
                ><i class="fas fa-pen orange"></i
              ></a>
              <a v-if="i == ranks.length - 1" @click="more('rank')" class="blue"
                ><i class="fas fa-plus"></i
              ></a>
            </div>
          </div>

          <div class="col-md-12 buttons row">
            <div class="col-md-3">
              <button @click="cancel()" class="belt-btn my-red-btn">
                Annulla
              </button>
            </div>
            <div class="col-md-4">
              <button @click="step -= 1" class="belt-btn my-orange-btn">
                Indietro
              </button>
            </div>

            <div class="col-md-5">
              <button @click="insert()" class="belt-btn my-green-btn">
                Inserisci
              </button>
            </div>
          </div>
        </div>

        <!-- ALERT -->
        <h1 v-if="alert !== ''" class="my-alert">Attenzione: {{ alert }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete'
export default {
  components: {
    VueGoogleAutocomplete
  },
  name: "add-listino",
  props: ["listini"],
  data() {
    return {

      alert: "",
      step: 1,
      shippingExists: false,
      shipping_prices: {
        nome: "",
        descrizione: "",
      },
      geo_areasNr: 1,
      geo_areas: [{ name: "", italy: true, ok: false }],
      geo_sugg: [],
      ranksNr: 1,
      ranks: [
        {
          min: 0.0,
          max: 0.0,
          stPrice: 0.0,
          exPrice: 0.0,
          ok: false,
        },
      ],
      suggestions: null,
    };
  },
  mounted() {
    //console.log(this.listini);
    this.focus("step1");
  },
  methods: {
    getAddressData(addressData, placeResultData, id) {
      //console.log(placeResultData)
      //console.log(id)
      let result = placeResultData
      if (result.types.includes('administrative_area_level_1') || result.types.includes('administrative_area_level_2') || result.types.includes('country')){
        //console.log(result.place_id, result.name)
        this.geo_sugg.push({
          id: id,
          name: result.name,
          place_id: result.place_id,
          area_type: result.types[0]
        })
        $('#'+id).prop('disabled', true)
        this.more('geo_area')
      } else {
        console.log('non valido')
        this.alertCustomError('Area non valida. Aree valide: stato, regione, provincia')
      }

    },

    getSuggestions(input){
      console.log('input: ',input)
      if (input.length >=3){
        axios({
          method: 'get',
          url: window.location.origin + '/googledebug',
          params: {
            address: input
          }
        }).then(res => {
          console.log('suggestions: ', res.data)
          this.suggestions = res.data
        })
      }
    },
    focus: function (element) {
      $("#" + element)
        .focus()
        .select();
    },
    alertCustomError(messaggio) {
      this.$buefy.dialog.alert({
        title: "Error",
        message: `${messaggio}`,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    more: function (key) {
      switch (key) {
        case "rank":
          this.ranksNr += 1;
          this.ranks.push({
            min: 0.0,
            max: 0.0,
            stPrice: 0.0,
            exPrice: 0.0,
            ok: false,
          });
          setTimeout(() => {
            this.focus("step3" + (this.ranksNr - 1));
          }, 1000);

          break;

        case "geo_area":
          this.geo_areasNr += 1;
          this.geo_areas.push({
            name: "",
            italy: true,
            ok: false,
          });
          setTimeout(() => {
            this.focus("step2" + (this.geo_areasNr - 1));
          }, 1000);

          break;
        default:
          break;
      }
    },
    cancel: function () {
      this.shipping_prices = {
        nome: "",
        descrizione: "",
      };
      this.ranksNr = 1;
      this.ranks = [
        {
          min: 0.0,
          max: 0.0,
          stPrice: 0.0,
          exPrice: 0.0,
          ok: false,
        },
      ];
      this.geo_areasNr = 1;
      this.geo_areas = [{ name: "", ok: false }];

      this.$emit("closeAdd");
    },
    prova: function (i) {
     // console.log(this.geo_areas[i].italy);
    },
    insert: function () {
      let rankArray = [];
      this.ranks.forEach((element) => {
        if (element.min !== 0 || element.max !== 0 || element.price !== 0) {
          let rankFloat = {
            min: parseFloat(element.min),
            max: parseFloat(element.max),
            stPrice: parseFloat(element.stPrice),
            exPrice: parseFloat(element.exPrice),
          };
          rankArray.push(rankFloat);
        }
      });
      // let geo_areaArray = [];
      // this.geo_areas.forEach((element) => {
      //   if (element.name != "") {
      //     if (element.italy) {
      //       element.name += ", italy";
      //     }
      //     geo_areaArray.push(element.name);
      //   }
      // });
      axios({
        method: "get",
        url: window.location.origin + "/admin/shipping",
        params: {
          action: "createsugg",
          nome: this.shipping_prices.nome,
          descrizione: this.shipping_prices.descrizione,
          address: this.geo_sugg,
          rank: rankArray,
        },
      })
        .then((res) => {
          console.log(res.data);
         // console.log("OK");
          this.$emit("inserito", "Inserito correttamente");
          this.cancel();
        })
        .catch((error) => {
          console.log(error.response.data);
          this.alertCustomError(error.response.data.message);
        });
    },
    step3: function () {
      this.step += 1;
      setTimeout(() => {
        this.focus("step3" + (this.ranksNr - 1));
      }, 1000);
    },
    step2: function () {
      if (this.shipping_prices.nome != "") {
        let index = this.listini.findIndex(
          (item) =>
            item.nome.toLowerCase() === this.shipping_prices.nome.toLowerCase()
        );
        if (index <= -1) {
          this.step += 1;
          this.alert = "";
          setTimeout(() => {
            this.focus("step2" + (this.geo_areasNr - 1));
          }, 1000);
        } else {
          let temp = this.shipping_prices.nome;
          this.shipping_prices = {
            nome: "",
            descrizione: "",
          };
          this.alert = "Il listino " + temp + " esiste già";
        }
      } else {
        this.alert = "Devi assegnare un nome al nuovo listino ";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: white;
  font-size: 24px;
  margin-bottom: 40px;
}
.body {
  background-color: white;
  padding: 20px 0; //  padding: 20px;

  margin: 0 auto;
  .belt-btn {
    margin-top: 20px;
  }
}

.row {
  margin: 0;
}
.rank {
  margin-top: 3.5rem;
}
.italia {
  input {
    width: 25px;
  }
}

.my-alert {
  background-color: var(--red);
  text-align: center;
  padding: 8px;
  margin: 15px;
}
.area-no{
  position: relative;
}
.suggestions {
  border: 1px solid black;
  position: absolute;
  height: 20px;
  right: 120px;
  bottom: -20px;
  z-index: 10;
}
@media (min-width: 576px) {
  .body {
    padding: 20px;

    .belt-btn {
    }
  }
}
</style>
